import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useAuthContext } from 'src/hooks/auth/use-auth-context';
import { useOrgTenant } from 'src/hooks/auth/use-org-tenant';

import { useTranslate } from 'src/locales';
import { useDeleteProfileDocumentMutation, useGetMyProfileQuery } from 'src/services/candidates/candidates.service';

import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useSettingsContext } from 'src/components/settings';

import { TenantType } from 'src/types/enums';

import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CandidateProfileDocumentsView from '../profile/documents/profile-documents';

export default function ProfileDocumentsContainer() {

  const settings = useSettingsContext();

  const authContext = useAuthContext();

  const tenantType = useOrgTenant();

  const { t } = useTranslate();

  const [deleteProfileDocument] = useDeleteProfileDocumentMutation();

  const { currentData: profileData } = useGetMyProfileQuery(undefined, {
    skip: tenantType !== TenantType.Candidate,
  });

  const handleDeleteFile = async (id: string) => {
    const toastId = enqueueSnackbar(t('profile.api.delete_document.loading'), { variant: 'loading' });

    try {
      await deleteProfileDocument(id).unwrap();
      enqueueSnackbar(t('profile.api.delete_document.success'), { variant: 'success' });

    } catch (error) {
      enqueueSnackbar(t('profile.api.delete_document.default_error'), { variant: 'error' });
    }
    finally {
      closeSnackbar(toastId);
    }
  };

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading={t('navigation.titles.documents')}
        links={[
          { name: t('navigation.titles.activity'), href: paths.dashboard.root },
          { name: t('navigation.titles.documents'), href: paths.dashboard.profile.documents },
          { name: authContext?.user?.name },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <CandidateProfileDocumentsView profileId={profileData?.id} onDelete={handleDeleteFile} />
    </Container>
  );
}
